module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('h2', {
    staticClass: "p-3 border-bottom-light"
  }, [_vm._v("Company Settings")]), _vm._v(" "), (_vm.loadingSettings) ? _c('div', {
    staticClass: "text-center mt-4"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "content"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "PROFILE"
    }
  }, [_c('tabCompany', {
    attrs: {
      "company": _vm.companySettings
    },
    on: {
      "save": _vm.saveSettings,
      "dirty-changed": _vm.onTabCompanyDirtyChanged
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "PRESETS"
    }
  }, [_c('tabPresets', {
    ref: "tabPresets",
    attrs: {
      "presets": _vm.companySettings.settingsPresets
    },
    on: {
      "update:presets": function($event) {
        _vm.companySettings.settingsPresets = $event
      },
      "dirty-changed": _vm.onTabPresetsDirtyChanged,
      "save": _vm.saveSettings
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "BOOKING WIDGET"
    }
  }, [_c('tabWidget', {
    on: {
      "save": _vm.saveSettings
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "INTEGRATIONS"
    }
  }, [_c('tabIntegrations', {
    attrs: {
      "presets": _vm.companySettings.settingsPresets
    },
    on: {
      "save": _vm.saveSettings
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "ACCOUNTS"
    }
  }, [_c('tabAccounts')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "SEGMENTATION"
    }
  }, [_c('tabSalesChannels')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "MY PLAN"
    }
  }, [_c('tabPlan')], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-fdfe39ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdfe39ee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Settings.vue
// module id = 2561
// module chunks = 0